// FT-186 REQ-05: серверный выключатель нативной камеры — поле nativeCamera ответа на
// APP_VERSION_PATH (utils/antiScrapeRetry). Последнее значение переживает перезапуск
// через createPersistedState (crmPersistReducer этот модуль не исключает) — офлайн-старт
// берёт его.
//
// null — «поля нет»: api ещё не выкачен или ответ без него. Тогда камера выключена (CON-01).
export function normalizeNativeCamera(value) {
  if (!value || typeof value !== "object") return null;
  return { ios: value.ios === true, android: value.android === true };
}

export default {
  namespaced: true,
  state: () => ({
    nativeCamera: null,
  }),
  mutations: {
    SET_NATIVE_CAMERA(state, value) {
      state.nativeCamera = normalizeNativeCamera(value);
    },
  },
  getters: {
    nativeCamera: (state) => state.nativeCamera,
  },
};
